import { render } from "./user-history.vue?vue&type=template&id=71acfd07"
import script from "./user-history.vue?vue&type=script&lang=js"
export * from "./user-history.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__